// extracted by mini-css-extract-plugin
export var button = "_jx-2";
export var card = "_jx-0";
export var closeButtonContainer = "_jx-3";
export var iconContainer = "_jx-1";